import React from "react";
import ReactECharts from "echarts-for-react";
const TopUsersChart = ({topUserChat = []}) => {
    const dataUserName = topUserChat.map(item => item.UserName);
    const dataTotalChat = topUserChat.map(item => item.TotalChats);

    const option = {
        title: { text: "Top Active Users", left: "center" },
        tooltip: { trigger: "axis" },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: { type: "value" },
        yAxis: {
            type: "category",
            data: dataUserName,
            axisTick: { show: false }
        },
        series: [
            {
                name: "Messages",
                type: "bar",
                data: dataTotalChat,
                itemStyle: { color: "rgba(80,130,255,0.8)", borderRadius: [0, 6, 6, 0] },
                barWidth: "50%"
            }
        ]
    };
    return <ReactECharts option={option} style={{ height: 300 }} />;
};
export default TopUsersChart;
